
import { Search } from 'vant'
import { checkBrowser } from '../../../assets/js/xjpublic';
// import { WeixinJSBridge } from '../../../libs/loadjs'

export default {
  name: 'home',
  components: {
    [Search.name]: Search
  },
  data () {
    return {
      text: 'demo'
    }
  },
  methods: {
    bindDeviceFn () {

    },
    errorNoteFn (errorText) {
      this.$dialog({
        message: errorText
      }).then(() => {
        // console.log(checkBrowser.isWx());
        if (checkBrowser.isWx()) {
          WeixinJSBridge.call('closeWindow');
        } else {
          // window.opener = null;
          // window.open('', '_self');
          window.location.href = 'about:blank';
          window.close();
        }
      })
    }
  },
  mounted () {
    // 获取页面传参
    let errorType = this.$route.query.type;
    let errorText = this.$route.query.text || '出错了！';
    if (errorType === 'wx') {
      errorText = '请在手机微信中打开！'
    } else if (errorType === 'tk') {
      errorText = '登录异常（011）'
    } else if (errorType === 'openid') {
      errorText = '参数错误（012）'
    } else if (errorType === 'customer') {
      errorText = '参数错误（013）'
    } else if (errorType === 'imei') {
      errorText = '未绑定设备（014）'
    }
    this.errorNoteFn(errorText);
  }
}
